<template><svg class="lu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path :d="paths[name] || paths.box" /></svg></template>
<script>
const paths = {
menu:'M4 6h16M4 12h16M4 18h16',close:'m6 6 12 12M18 6 6 18',
arrow:'m9 5 7 7-7 7',search:'M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
box:'m3 7 9-5 9 5v10l-9 5-9-5V7Zm0 0 9 5 9-5M12 12v10M7.5 4.5l9 5',
user:'M20 21v-2a6 6 0 0 0-6-6h-4a6 6 0 0 0-6 6v2M16 5a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
lock:'M6 10h12v11H6V10Zm2 0V6a4 4 0 0 1 8 0v4M12 14v3',
mail:'M3 5h18v14H3V5Zm0 1 9 7 9-7',shield:'M12 3 4 6v6c0 4.5 3.4 8.2 8 9 4.6-.8 8-4.5 8-9V6l-8-3Zm-3.5 9 2.5 2.5 4.5-4.5',
file:'M14 2H5v20h14V7l-5-5Zm0 0v6h5M8 13h8M8 17h6',
check:'m5 12 4 4L19 6',info:'M12 11v6M12 7h.01M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
eye:'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Zm13 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
download:'M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5',logout:'M9 3H3v18h6M8 12h13m-5-5 5 5-5 5',
globe:'M2 12h20M12 2c6 6 6 14 0 20-6-6-6-14 0-20ZM22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
users:'M16 21v-3a5 5 0 0 0-5-5H8a5 5 0 0 0-5 5v3M13 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0M17 3a4 4 0 0 1 0 8M19 14a5 5 0 0 1 3 4v3'
};
export default { name: 'UiIcon', props: { name: { type: String, default: 'box' } }, data: () => ({ paths }) };
</script>
